import React, { FC } from 'react';

import { imageBorderRadius } from 'themes';
import ImageContainer from './index';

interface BannerContainerProps {
  containerAttr: any;
  imageAttr: any;
}

export const BannerContainer: FC<BannerContainerProps> = ({ children, containerAttr, imageAttr }) => (
  <ImageContainer
    containerAttr={{
      ...containerAttr,
      styles: `
        position: relative;
        margin: 5px;
        font-size: 0;
      `
    }}
    imageAttr={{
      ...imageAttr,
      styles: `
        border-radius: ${imageBorderRadius};
      `
    }}
  >
    {children}
  </ImageContainer>
);
